import React from 'react';
import {connect} from 'react-redux';
import Currency from '../../../components/numbers/Currency';
import ArrLeftButton from '../../../components/buttons/ArrLeftButton';
import ArrRightButton from '../../../components/buttons/ArrRightButton';
import {clearMenuHabitues, fetchMenuHabitues} from '../../../../common/menu/credit/habitues/actions';
import {chooseHabitueDetail, clearBillCheckbox} from '../../../../common/menu/credit/debtDetail/actions';

class Habitues extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        page: React.PropTypes.number,
        limit: React.PropTypes.number,
        max: React.PropTypes.number,
        habitues: React.PropTypes.object,
        branchId: React.PropTypes.number,
        clearBillCheckbox: React.PropTypes.func,
        chooseHabitueDetail: React.PropTypes.func,
        clearMenuHabitues: React.PropTypes.func,
        fetchMenuHabitues: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
    }

    nextPage() {
        const {fetchMenuHabitues, branchId, limit, page} = this.props;
        fetchMenuHabitues(branchId, limit, page + 1);
    }

    prevPage() {
        const {fetchMenuHabitues, branchId, limit, page} = this.props;
        fetchMenuHabitues(branchId, limit, page - 1);
    }

    componentWillMount() {
        const {fetchMenuHabitues, branchId, limit, page, clearBillCheckbox} = this.props;
        fetchMenuHabitues(branchId, limit, page);
        clearBillCheckbox();
    }

    componentWillUnmount() {
        const {clearMenuHabitues} = this.props;
        clearMenuHabitues();
    }

    render() {
        const {habitues, max, page, limit, chooseHabitueDetail, msg} = this.props;

        return (
            <div id="bills-list" className="pageTables with-header">
                <div className="pageTables-controls view-top">
                  <div className="pageTables-controls-title" style={{width: '77.77%'}}>
                    <div className="pageTables-title">
                        {msg.menu.credits}
                    </div>
                  </div>
                  <div className="pageTables-controls-key">
                    <div className={`boxBtn color-white ${page < 1 ? 'disabled' : ''}`}
                         onClick={() => this.prevPage()}>
                        <ArrLeftButton/>
                    </div>
                  </div>
                  <div className="pageTables-controls-key">
                    <div
                        className={`boxBtn color-white ${max <= limit || page === (Math.ceil(max / limit) - 1) ? 'disabled' : ''}`}
                        onClick={() => this.nextPage()}>
                        <ArrRightButton/>
                    </div>
                  </div>
                </div>
                {habitues.map((hab, i) =>
                  <div key={`habitues-${i}`} className="pageTables-key">
                    <div
                         onClick={() => chooseHabitueDetail(hab.get('id'), page)}
                         className={`boxBtn color-greenLight`}>
                        <div className="boxBtn-inner">
                            <span>
                                {hab.get('fullName')} <Currency isBlock={true} value={Math.round(hab.get('amount'))} currency={hab.get('currency')}/>
                            </span>
                        </div>
                    </div>
                  </div>
                )}

            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    branchId: state.branches.getIn(['branch', 'id']),
    limit: state.menuHabitues.get('limit'),
    page: state.menuHabitues.get('page'),
    max: state.menuHabitues.get('max'),
    habitues: state.menuHabitues.get('habitues')
}), {
    clearMenuHabitues, fetchMenuHabitues, chooseHabitueDetail, clearBillCheckbox
})(Habitues);



// WEBPACK FOOTER //
// ./src/browser/menu/credit/habitues/Habitues.js